import * as React from "react";
import { FC } from "react";
import theme from "styles/theme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Switch, { SwitchProps } from "@material-ui/core/Switch";
import classNames from "classnames";

const Toggle: FC<SwitchProps> = (props) => {
    const { classes } = props;
    const toggleClasses = useStyles({});
    return (
        <Switch
            classes={{
                switchBase: classNames(toggleClasses.switchBase, classes?.switchBase),
                track: classNames(toggleClasses.track, classes?.track),
                thumb: classNames(toggleClasses.thumb, classes?.thumb),
                checked: classNames(toggleClasses.checked, classes?.checked),
                input: classNames(toggleClasses.input, classes?.input),
                ...classes,
            }}
            {...props}
        />
    );
};

const useStyles = makeStyles({
    switchBase: {
        "&$checked": {
            color: "white",
            "& + $track": {
                backgroundColor: theme.toggle.trackOnColor,
                opacity: 1,
            },
            "&:hover,focus": {
                backgroundColor: "rgba(117, 194, 188, 0.09)", // theme.toggle.trackOnColor
            },
        },
    },
    thumb: {
        boxShadow: "rgb(0 0 0 / 12%) 0px 1px 6px, rgb(0 0 0 / 12%) 0px 1px 4px",
    },
    track: {
        backgroundColor: theme.toggle.trackDisabledColor,
        opacity: 1,
    },
    input: {
        margin: "0 !important", //  CSS issues in Chrome
    },
    checked: {},
});

export default Toggle;
